import { Cpu, BatteryMedium } from "lucide-react";
import { nf, ago } from "./shared";

const DOT = { 1: "#22c55e", 2: "#ef4444", 3: "#f59e0b", 4: "#737373" };

export function InverterList({ p }) {
  const live = p.inverters_live?.length ? p.inverters_live : p.inverters || [];
  if (live.length < 2) return null;
  const fermi = live.filter((i) => i.light && i.light !== 1).length;
  return (
    <div className="space-y-2" data-testid="plant-inverter-list">
      <div className="flex flex-wrap items-center gap-2 text-[11px] font-bold uppercase tracking-widest text-neutral-400">
        <Cpu className="h-3.5 w-3.5" />{live.length} inverter
        <span className={fermi ? "text-amber-400" : "text-emerald-400"} data-testid="plant-inverter-summary">{fermi ? `· ${fermi} da verificare` : "· tutti in produzione"}</span>
      </div>
      <div className="grid gap-2 sm:grid-cols-2">
        {live.map((i) => (
          <div key={i.sn} className="rounded-xl border border-neutral-800 px-3 py-2 text-xs" data-testid={`plant-inverter-${i.sn}`}>
            <div className="flex items-center gap-2">
              <span className="h-2 w-2 rounded-full" style={{ background: DOT[i.light] || DOT[4] }} />
              <b className="text-white">{i.model}</b>
              {i.soc != null && <span className="ml-auto inline-flex items-center gap-1 text-emerald-400"><BatteryMedium className="h-3.5 w-3.5" />{i.soc}%</span>}
            </div>
            <div className="mt-1 font-mono text-[11px] text-neutral-400">SN {i.sn}</div>
            <div className="mt-1 flex flex-wrap gap-x-3 text-neutral-400">
              {i.pac_w != null && <span>Ora <b className="text-neutral-200">{nf(i.pac_w / 1000)} kW</b></span>}
              {i.e_oggi_kwh != null && <span>Oggi <b className="text-neutral-200">{nf(i.e_oggi_kwh)} kWh</b></span>}
              {i.data_time && <span>Ultimo dato {ago(i.data_time)}</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
